import React from "react";
import { Provider } from "react-redux";
import { TrackJS } from "trackjs";
import DigitalGiftCardsContainer from "containers/digital_gift_cards_container";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
function DigitalGiftCardsApp(_a) {
    var store = _a.store, flags = _a.flags;
    if (!store || !store.getState()) {
        TrackJS.track("Redux store and state not initialized in app.");
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Provider, { store: store },
        React.createElement(DigitalGiftCardsContainer, { flags: flags })));
}
export default withLDConsumer()(DigitalGiftCardsApp);
